import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useUserStore = defineStore('user', () => {
  // 响应式状态
  const user = ref(JSON.parse(localStorage.getItem('user') || 'null'));
  const token = ref(localStorage.getItem('token') || null);

  // 计算属性
  const isLoggedIn = computed(() => !!token.value);
  const username = computed(() => user.value?.username || '');
  const userRole = computed(() => user.value?.role || '');

  // Actions
  const setUser = (userData) => {
    user.value = userData;
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const clearUser = () => {
    user.value = null;
    localStorage.removeItem('user');
  };

  const setToken = (tokenData) => {
    token.value = tokenData;
    localStorage.setItem('token', tokenData);
  };

  const clearToken = () => {
    token.value = null;
    localStorage.removeItem('token');
  };

  // 登录操作
  const login = (userData, tokenData) => {
    setUser(userData);
    setToken(tokenData);
  };

  // 退出登录操作
  const logout = () => {
    clearUser();
    clearToken();
  };

  // 更新用户信息
  const updateUser = (userData) => {
    if (user.value) {
      user.value = { ...user.value, ...userData };
      localStorage.setItem('user', JSON.stringify(user.value));
    }
  };

  return {
    // 状态
    user,
    token,
    
    // 计算属性
    isLoggedIn,
    username,
    userRole,
    
    // Actions
    setUser,
    clearUser,
    setToken,
    clearToken,
    login,
    logout,
    updateUser
  };
});